import React from 'react';

import PropTypes from 'prop-types';
import { Transition } from 'react-transition-group';
import styled from 'styled-components';

import {
  FormattedMessage,
  FormattedNumber,
} from '~/techstyle-shared/react-intl';

import useSelectedFacetsToApply from '../../hooks/useSelectedFacetsToApply';

const LabelText = styled.span`
  margin: 0 5px;
`;

const StyledButton = styled.button`
  background-color: black;
  color: white;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 23px;
  padding: 8px;
  margin-top: 16px;
  font-size: 14px;
  min-width: 88px;
  font-family: inherit;
  border: none;
  cursor: pointer;

  transform: translate3d(0, 0, 0);
  transition: all ${(props) => props.$transitionDuration}ms;

  &[data-transition-state='exiting'],
  &[data-transition-state='exited'] {
    /* There's no default margin, but if the consumer overrides margin, we
       should transition it to 0 on exit. */
    margin-top: 0;
    transform: translate3d(0, -100%, 0);
  }
`;

const MobileGridFloatingFilter = ({
  isVisible = false,
  onClick = () => {},
  transitionDuration = 300,
}) => {
  const { selectedFacetsToApply } = useSelectedFacetsToApply();

  const filterCount = Object.values(selectedFacetsToApply).reduce(
    (acc, selectedFacetOptions) => {
      return acc + selectedFacetOptions?.length || 0;
    },
    0
  );

  return (
    <Transition
      in={isVisible}
      mountOnEnter
      unmountOnExit
      timeout={transitionDuration}
    >
      {(state) => (
        <StyledButton
          type="button"
          onClick={onClick}
          $transitionDuration={transitionDuration}
          data-transition-state={state}
        >
          <LabelText>
            <FormattedMessage
              id="site_product_grid.filters_title"
              defaultMessage="Filters"
            />
          </LabelText>
          {filterCount > 0 && (
            <FormattedMessage
              id="site_product_filter.filter_count"
              defaultMessage="({filterCount})"
              values={{
                filterCount: <FormattedNumber value={filterCount} />,
              }}
            />
          )}
        </StyledButton>
      )}
    </Transition>
  );
};

MobileGridFloatingFilter.propTypes = {
  isVisible: PropTypes.bool,
  onClick: PropTypes.func,
  transitionDuration: PropTypes.number,
};

export default MobileGridFloatingFilter;
